/* eslint-disable no-use-before-define, no-param-reassign, camelcase */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { throwErrorByCodeStatus } from 'Utils/Errors/throwErrorByCodeStatus';
import { TokenExpiredError } from 'Utils/Errors/TokenExpiredError';
import { JSOG } from 'Utils/JSOG';
import { JSOGDeleteCircular } from 'Utils/JSOG.utils';
import { toaster } from 'evergreen-ui';
import store from 'Features/App/store';

function onTokenExpired() {
  const token_expired_message = 'Время сессии истекло! Войдите заново что бы продолжить!';
  store.dispatch(dcpcApi.endpoints.logout.initiate());
  const isToasterDisplayed = toaster.getToasts().find((el) => el.title === token_expired_message);
  if (!isToasterDisplayed) toaster.warning(token_expired_message);
}

export function dcpcResponseErrorTypeChecker(result, extraOptions) {
  if (result.error) {
    try {
      throwErrorByCodeStatus(result.meta.response, result.error.data?.path, result.error);
    } catch (err) {
      if (err instanceof TokenExpiredError) {
        onTokenExpired();
        result.error.data.message = null;
      } else {
        // в queryApi прописываем extraOptions: {toasterMessage: message}, если нужна кастомная ошибка
        // catch больше не прописывается нигде
        !extraOptions?.noToaster && toaster.danger(extraOptions?.toasterMessage || err.message);
        result.error.data = { ...result.error.data, message: err.message };
        result.error.message = err.message;
      }
    }
  }
}

// если args.useXmlFetcher = true использует xmlFetcher, а не fetchBaseQuery (вследствие имеет немного другое поведение)
const xmlFetcher = (config) => async (args) => {
  try {
    const file = await (await fetch(`${config.baseUrl}/${args.url}`, {
      headers: args.headers,
      method: args.method,
    })).text();
    return { data: file };
  } catch (err) {
    return { error: err };
  }
};

// Расширение rtkq функционала запросов
async function fetchCustomizer(args, config, obj) {
  // Xml файлы не загружаются через fetchBaseQuery
  const ftch = args.useXmlFetcher ? xmlFetcher(config) : fetchBaseQuery(config);
  const result = await ftch(args, obj);

  // Loop pulling
  // if (args.loopPulling) {
  //     const detector = args.loopPulling?.key || ((original) => original?.data?.dateTimePullMore);
  //     const patcher = args.loopPulling?.assigner || ((original, pull) => valueAssign(original, pull));
  //     const actualizer = args.loopPulling?.actualizer || args.loopPulling;
  //     if (actualizer && typeof actualizer === 'function') {
  //         const detected = detector(result);
  //         if (detected) {
  //             const actualizedArgs = actualizer(detected, result);
  //             const pull = await fetchCustomizer(actualizedArgs, config, obj);
  //             patcher(result, pull);
  //         }
  //     }
  // }

  return result;
}

// Обертка
const dcpcFetchBase = (config) => async (args, obj, options) => {
  const result = await fetchCustomizer(args, config, obj);
  dcpcResponseErrorTypeChecker(result, options || null);

  return JSOGDeleteCircular(JSOG.decode((result)));
};

export const MAIN_API_REDUCER_PATH = 'dcpcApi';
export const dcpcApi = createApi({
  reducerPath: MAIN_API_REDUCER_PATH,
  refetchOnFocus: false,
  baseQuery: dcpcFetchBase({
    baseUrl: process.env.REACT_APP_API_PREFIX,
    // Закоментил потому что xml не отправляется. Вроде все работает и так
    // prepareHeaders: ((headers) => {
    //   headers.set('Content-Type', 'application/json; charset=utf-8');
    //   return headers;
    // }),
  }),
  endpoints: () => ({}),
  // tagTypes: ['station', 'station-datasource'],
});

export const {
  invalidateTags,
} = dcpcApi.util;
